var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'items-center': _vm.itemsCenter},'table-row'],style:({'grid-template-columns': _vm.columnTemplates, 'background-color': _vm.bgRow}),on:{"click":_vm.getData}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }